import { KeyRound } from 'lucide-react';
import SalasananVaihto from '../components/SalasananVaihto';
import { useKaannos } from '../lib/i18n';

/**
 * Näkymä, joka korvaa koko sovelluksen silloin kun ylläpitäjän asettama
 * salasana on vaihdettava (suunnitelma 13.2.1).
 *
 * Tämä on käytettävyyttä, ei turvaa: palvelin torjuu jokaisen muun
 * päätteen samalla ehdolla (`plugins/auth.ts`). Ilman tätä näkymää
 * käyttäjä näkisi vain rivin virheilmoituksia eikä sitä, mitä pitäisi
 * tehdä.
 *
 * Uloskirjautuminen tulee propsina eikä `useLogout`-koukusta: näkymän
 * renderöi `lib/session`, ja tuonti sinne päin tekisi moduuleista
 * kehämäiset.
 */
export default function PakotettuSalasananVaihto({ onLogout }: { onLogout: () => void }) {
  const { t } = useKaannos();

  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <div className="border-reuna bg-pinta-korotettu w-full max-w-sm rounded-xl border p-8 shadow-sm">
        <KeyRound className="text-korostus size-6" aria-hidden="true" />
        <h1 className="text-teksti mt-3 text-lg font-semibold tracking-tight">
          {t('salasana.pakkoOtsikko')}
        </h1>
        <p className="text-teksti-vaimea mt-1 text-sm leading-relaxed">
          {t('salasana.pakkoSelite')}
        </p>

        <div className="mt-6">
          <SalasananVaihto />
        </div>

        <button
          type="button"
          onClick={onLogout}
          className="text-teksti-vaimea hover:text-teksti mt-4 text-xs underline"
        >
          {t('navi.kirjauduUlos')}
        </button>
      </div>
    </div>
  );
}
